export default {
  en: {
    title: 'Knowledge base',
    intro: 'Collected from your conversations.',
    addPlaceholder: 'Add something yourself',
    addSubmit: 'Add',
    emptyState:
      'Nothing yet. After a few real conversations the tutor will start remembering things about you.',
    loading: 'Loading',
    deleteFact: 'Forget this',
    sectionThread: 'Waiting to hear how it went',
    sectionBackground: 'About you',
    sectionAvoid: 'Never brings up',
    temporary: 'Temporary',
    addedByYou: 'added by you',
    expectedToday: 'today',
    expectedTomorrow: 'tomorrow',
    expectedInDays: 'in {{count}} days',
    expectedYesterday: 'yesterday',
    expectedDaysAgo: '{{count}} days ago',
  },
  ru: {
    title: 'База знаний',
    intro: 'Собрано из наших разговоров.',
    addPlaceholder: 'Добавить своё',
    addSubmit: 'Добавить',
    emptyState:
      'Пока пусто. Поговорим пару раз, и база знаний начнёт наполняться.',
    loading: 'Загружаю',
    deleteFact: 'Забыть это',
    sectionThread: 'Узнаем, как всё прошло',
    sectionBackground: 'О тебе',
    sectionAvoid: 'Не поднимаем эти темы',
    temporary: 'Временное',
    addedByYou: 'добавлено тобой',
    expectedToday: 'сегодня',
    expectedTomorrow: 'завтра',
    expectedInDays: 'через {{count}} дн.',
    expectedYesterday: 'вчера',
    expectedDaysAgo: '{{count}} дн. назад',
  },
  de: {
    title: 'Wissensbasis',
    intro: 'Gesammelt aus deinen Gesprächen.',
    addPlaceholder: 'Etwas Eigenes hinzufügen',
    addSubmit: 'Hinzufügen',
    emptyState:
      'Noch nichts da. Nach ein paar echten Gesprächen merkt sich der Tutor Dinge über dich.',
    loading: 'Lade',
    deleteFact: 'Das vergessen',
    sectionThread: 'Wartet darauf, wie es ausging',
    sectionBackground: 'Über dich',
    sectionAvoid: 'Bringt nie zur Sprache',
    temporary: 'Vorübergehend',
    addedByYou: 'von dir hinzugefügt',
    expectedToday: 'heute',
    expectedTomorrow: 'morgen',
    expectedInDays: 'in {{count}} Tagen',
    expectedYesterday: 'gestern',
    expectedDaysAgo: 'vor {{count}} Tagen',
  },
  pt: {
    title: 'Base de conhecimento',
    intro: 'Coletado das suas conversas.',
    addPlaceholder: 'Adicione algo seu',
    addSubmit: 'Adicionar',
    emptyState:
      'Nada por aqui ainda. Depois de algumas conversas reais, o tutor vai começar a se lembrar de coisas sobre você.',
    loading: 'Carregando',
    deleteFact: 'Esquecer isso',
    sectionThread: 'Aguardando saber como foi',
    sectionBackground: 'Sobre você',
    sectionAvoid: 'Nunca menciona',
    temporary: 'Temporário',
    addedByYou: 'adicionado por você',
    expectedToday: 'hoje',
    expectedTomorrow: 'amanhã',
    expectedInDays: 'em {{count}} dias',
    expectedYesterday: 'ontem',
    expectedDaysAgo: 'há {{count}} dias',
  },
  fr: {
    title: 'Base de connaissances',
    intro: 'Recueilli lors de tes conversations.',
    addPlaceholder: 'Ajoute quelque chose de toi',
    addSubmit: 'Ajouter',
    emptyState:
      'Rien pour l’instant. Après quelques vraies conversations, le tuteur commencera à retenir des choses sur toi.',
    loading: 'Chargement',
    deleteFact: 'Oublier ça',
    sectionThread: 'Attend de savoir comment ça s’est passé',
    sectionBackground: 'À propos de toi',
    sectionAvoid: 'N’aborde jamais',
    temporary: 'Temporaire',
    addedByYou: 'ajouté par toi',
    expectedToday: 'aujourd’hui',
    expectedTomorrow: 'demain',
    expectedInDays: 'dans {{count}} jours',
    expectedYesterday: 'hier',
    expectedDaysAgo: 'il y a {{count}} jours',
  },
  es: {
    title: 'Base de conocimientos',
    intro: 'Recopilado de tus conversaciones.',
    addPlaceholder: 'Añade algo tuyo',
    addSubmit: 'Añadir',
    emptyState:
      'Todavía no hay nada. Después de unas conversaciones reales, el tutor empezará a recordar cosas sobre ti.',
    loading: 'Cargando',
    deleteFact: 'Olvidar esto',
    sectionThread: 'Espera saber cómo fue',
    sectionBackground: 'Sobre ti',
    sectionAvoid: 'Nunca menciona',
    temporary: 'Temporal',
    addedByYou: 'añadido por ti',
    expectedToday: 'hoy',
    expectedTomorrow: 'mañana',
    expectedInDays: 'en {{count}} días',
    expectedYesterday: 'ayer',
    expectedDaysAgo: 'hace {{count}} días',
  },
};
